<template>
    <div class="footer">
<div class="container mt-5 mb-5">


        <div class="row">
            <div class="col-md-3 col-sm-6">
                <div class="footer-title"><img src="../assets/img/LOGO_AKANEA.webp" class="img-fluid" alt=""></div>
                <div class="footer-link"><img src="../assets/img/iconLocation.png" class="mr-2" alt="iconlocation"><a href="">3 All. Albert Caquot br 51100 Reims <br>France</a></div>
               
                
            </div>
            <div class="col-md-3 col-sm-6">
                
                <div class="footer-link"><router-link to="/solutions/fleet">{{ $t('footer.fleet') }}</router-link></div>
                
            </div>

            <div class="col-md-3 col-sm-6">
                <div class="footer-title">{{ $t('footer.ressources') }}</div>

                 <div class="footer-link"><router-link to="/private"> <i class="fas fa-user-lock"></i> {{ $t('footer.private') }}</router-link> </div>
                 <!-- <div class="footer-link"><router-link to="/contact-demo"> {{ $t('footer.demo') }}</router-link> </div> -->
            </div>

            <div class="col-md-3 col-sm-6">
                <div class="footer-title">{{ $t('footer.entreprise') }}</div>
                
                <div class="footer-link"><router-link to="/solutions/digitappro/rgpd"> {{ $t('footer.rgpd') }}</router-link></div>
               
            </div>
            
        </div>
        
        <div class="container bottomBar row">
            <div class="leftPart">
                <a href="">Akanea Reims</a>

            </div>

        </div>
    </div>
    </div>
    
</template>

<script>
export default {
  name: 'Footer',
  props: {}
}



</script>

<style lang="scss" scoped>


.footer-title{
    text-transform: uppercase;
    font-size: 25px;
    margin: 15px 0px;
}
.footer-link{
    margin: 15px 0px;
    opacity: 0.8;
    font-weight: 500;
    a{
        color: var(--mainBlue);
    }
}
.partners{
    margin-bottom: 50px;
    img{
        height: 150px;
    }
    .footer-title{
    text-transform: uppercase;
    font-size: 25px;
    font-weight: 700;
    margin: 15px 0px;
}
}
.bottomBar{
    padding: 100px 0px 0px 0px;

    a{
        color: grey;
    }
    .leftPart{
        a{
            margin-right: 20px;
        }
        text-align: left;
        font-size: 13px;
    }
    .rightPart{
        text-align: right;
        font-size: 20px;
        a{
            margin-left: 20px;
        }
    }
}

</style>